import { t } from 'i18next'

import { FormGroup, Input, Label } from '~/components/unform'

export const GenericIdentificationNumber = () => (
  <FormGroup className="span2">
    <Label>{t('rm:payment.billing.identificationNumber.label')}</Label>
    <Input
      name="identificationNumber"
      placeholder={t('rm:payment.billing.identificationNumber.placeholder')}
      required
    />
  </FormGroup>
)
